import { request } from './base.service';

const generateId = () =>
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });

export interface CategoryLimit {
    category: string;
    interval: 'weekly' | 'monthly' | 'quarterly' | 'yearly';
    limit: number;
    field?: 'category' | 'tag';
}

export interface ListUpdate {
    categoryLimits?: CategoryLimit[];
    startingBalance?: number | null;
    creditOwed?: number | null;
}

// Backend returns { lists: [{ listid, name, entryCount, categoryLimits, startingBalance, creditOwed, createdAt, updatedAt }] }
// App uses { id, displayName, categoryLimits, startingBalance, creditOwed }
const toAppList = (l: any) => ({
    id: l.listid,
    displayName: l.name || l.listid,
    categoryLimits: Array.isArray(l.categoryLimits) ? l.categoryLimits : [],
    startingBalance: l.startingBalance != null ? Number(l.startingBalance) : null,
    creditOwed: l.creditOwed != null ? Number(l.creditOwed) : null,
});

export const getLists = async (userId: string) => {
    const data = await request(`/lists/${userId}`);
    const raw: any[] = data?.lists ?? [];
    return { value: raw.map(toAppList) };
};

export const createList = async (userId: string, data: { displayName: string; id?: string }) => {
    const newList = { id: data.id || generateId(), displayName: data.displayName };
    await request(`/lists/${userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newList),
    });
    return newList;
};

export const deleteList = async (userId: string, listId: string) => {
    await request(`/lists/${userId}/${listId}`, { method: 'DELETE' });
};

export const updateList = async (userId: string, listId: string, fields: ListUpdate) => {
    await request(`/lists/${userId}/${listId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userid: userId, listid: listId, ...fields }),
    });
};

export const updateListLimits = (userId: string, listId: string, categoryLimits: CategoryLimit[]) =>
    updateList(userId, listId, { categoryLimits });
